import Cookies from "js-cookie";
class Disclaimer {
    static initEvents() {
        document.addEventListener("DOMContentLoaded", Disclaimer.initDisclaimer);
    }
    static initDisclaimer() {
        if (Disclaimer.getDismissedCookie() === "true") {
            return;
        }
        const modal = document.getElementById("modal-disclaimer");
        const form = document.getElementById("form-disclaimer");
        if (modal === null)
            throw new Error("Modal element not found");
        if (form === null)
            throw new Error("Form element not found");
        const showCheckboxError = () => {
            const error = document.querySelector("#disclaimer_confirmation_error");
            if (error === null) {
                throw new Error("Checkbox error element not found");
            }
            error.classList.toggle("show", true);
        };
        form.addEventListener("submit", (event) => {
            var _a;
            event.preventDefault();
            // Check that confirmation checkbox is checked
            const checkbox = form.querySelector("#disclaimer_confirmation");
            const isChecked = (_a = checkbox === null || checkbox === void 0 ? void 0 : checkbox.checked) !== null && _a !== void 0 ? _a : false;
            if (!isChecked) {
                showCheckboxError();
                return;
            }
            Disclaimer.setDismissedCookie();
            modal.removeAttribute("open");
        });
        // Show the modal after a short delay, to ensure it doesn't block the initial page load
        if (document.readyState === "loading") {
            // DOM not ready, add event listener
            document.addEventListener("DOMContentLoaded", () => {
                setTimeout(() => {
                    modal.setAttribute("open", "true");
                }, 600);
            });
        }
        else {
            // DOM already ready
            setTimeout(() => {
                modal.setAttribute("open", "true");
            }, 600);
        }
    }
    static getDismissedCookie() {
        return Cookies.get("disclaimer_dismissed");
    }
    static setDismissedCookie(value = "true") {
        Cookies.set("disclaimer_dismissed", value, { expires: 7 });
    }
}
Disclaimer.initEvents();
